import { render, staticRenderFns } from "./icon-arrow-tertiary.vue?vue&type=template&id=0a8b2480&scoped=true&"
import script from "./icon-arrow-tertiary.vue?vue&type=script&lang=js&"
export * from "./icon-arrow-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8b2480",
  null
  
)

export default component.exports